import { PageHeader } from "@/components/PageHeader";
import { AddBankForm } from "@/components/settings/AddBankForm";
import { BankCard } from "@/components/settings/BankCard";
import { ScrapingScheduleSettings } from "@/components/settings/ScrapingScheduleSettings";
import * as shared from "@/styles/shared";
import { BankSettingsProvider, useBankSettings } from "@shared/contexts";
import { FormMode } from "@shared/types/settings";
import { Building2, Clock, MessageSquare, Plus, Settings as SettingsIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import * as styles from "./SettingsPage.styles";

const SettingsPage = () => (
  <BankSettingsProvider>
    <Inner />
  </BankSettingsProvider>
);

const Inner = () => {
  const { t } = useTranslation("settings");
  const settings = useBankSettings();

  if (settings.loading) return <p className={shared.muted}>{t("loading")}</p>;
  if (!settings.banks?.length && settings.error) return <p className={shared.errorText}>{settings.error}</p>;

  return (
    <div className={shared.page}>
      <PageHeader icon={SettingsIcon} title={t("pageTitle")} />

      <div className={styles.section}>
        {/* Bank Providers Card */}
        <div className={styles.card}>
          <div className={styles.headerRow}>
            <div className={styles.cardHeaderRow}>
              <Building2 className={styles.cardHeaderIcon} />
              <h2 className={shared.headingLg}>{t("bankProviders")}</h2>
            </div>
            {settings.formMode !== FormMode.ADD && (
              <button onClick={settings.startAdding} className={styles.addBankButton}>
                <Plus size={16} strokeWidth={2.5} /> {t("addBank")}
              </button>
            )}
          </div>

          {settings.formMode === FormMode.ADD && <AddBankForm />}

          {!!settings.banks?.length && (
            <div className={styles.bankList}>
              {settings.banks.map((bank) => (
                <BankCard key={bank.id} bank={bank} />
              ))}
            </div>
          )}

          {!settings.banks?.length && !settings.loading && <p className={shared.muted}>{t("noBanks")}</p>}
        </div>

        <div className={styles.card}>
          <div className={styles.discordHeader}>
            <MessageSquare className={styles.discordIcon} />
            <h2 className={shared.headingLg}>{t("discord")}</h2>
          </div>
          <div className={styles.settingItem}>
            <p>{t("notificationsConfigured")}</p>
            <p>{t("channelConfigured")}</p>
          </div>
        </div>

        <div className={styles.card}>
          <div className={styles.scheduleHeader}>
            <Clock className={styles.scheduleIcon} />
            <h2 className={shared.headingLg}>{t("scrapingSchedule")}</h2>
          </div>
          <p className={shared.muted}>{t("scrapingScheduleDescription")}</p>
          <ScrapingScheduleSettings />
        </div>
      </div>

      {settings.error && !!settings.banks?.length && <p className={shared.errorText}>{settings.error}</p>}
    </div>
  );
};

export default SettingsPage;
